module.exports = __webpack_public_path__ + "static/okonomie1-9b8f39602a31b53487d737d872ce65e6.png";